/**
 * Lavelle Luxury Boutique Theme Core JS
 */

window.Lavelle = window.Lavelle || {};

// Toast notification helper
Lavelle.showToast = function(message, duration = 3500) {
  let toast = document.getElementById('lavelle-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'lavelle-toast';
    toast.className = 'toast-notification';
    document.body.appendChild(toast);
  }
  toast.innerHTML = `<span>${message}</span>`;
  toast.classList.add('active');
  
  if (toast.timeout) clearTimeout(toast.timeout);
  toast.timeout = setTimeout(() => {
    toast.classList.remove('active');
  }, duration);
};

// Modal Helper
Lavelle.openModal = function(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
};

Lavelle.closeModal = function(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
};

document.addEventListener('DOMContentLoaded', () => {
  // Setup Accordions
  document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const content = trigger.nextElementSibling;
      const isOpen = trigger.classList.contains('active');
      
      // Close other accordions in the same group if requested
      if (trigger.dataset.accordionGroup) {
        document.querySelectorAll(`[data-accordion-group="${trigger.dataset.accordionGroup}"]`).forEach(otherTrigger => {
          if (otherTrigger !== trigger) {
            otherTrigger.classList.remove('active');
            if (otherTrigger.nextElementSibling) {
              otherTrigger.nextElementSibling.style.maxHeight = null;
            }
          }
        });
      }

      if (isOpen) {
        trigger.classList.remove('active');
        content.style.maxHeight = null;
      } else {
        trigger.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  // Mobile Menu Drawer Toggle
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileDrawer = document.getElementById('mobile-menu-drawer');
  const mobileClose = document.querySelector('[data-mobile-menu-close]');
  
  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', () => {
      mobileDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileDrawer) {
    mobileClose.addEventListener('click', () => {
      mobileDrawer.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  // Close modals on backdrop click or close button
  document.querySelectorAll('.modal-overlay').forEach(overlay => {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay || e.target.closest('[data-modal-close]')) {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });
});
